import React, { ReactElement, useCallback, useEffect, useState } from 'react';
import FadeIn from 'react-fade-in';
import { useHistory } from 'react-router-dom';
import logo from './img/logo.webp';

export default function Home(): ReactElement {
    const [tab, setTab] = useState(window.location.hash === '#about' ? 1 : 0);
    const [hide, setHide] = useState(false);

    const switchTab = useCallback((newTab?: any) => {
        const newTabIndex = typeof newTab === 'number' ? newTab : 1 - tab;

        setHide(true);
        window.location.hash = newTabIndex === 1 ? 'about' : '';

        window.setTimeout(() => {
            setTab(newTabIndex);
            setHide(false);
        }, 400);
    }, [tab]);

    useEffect(() => {
        window.onhashchange = () => {
            switchTab(window.location.hash === '#about' ? 1 : 0);
        }
    }, []);

    const history = useHistory();

    return (
        <FadeIn
            className={ `home${ hide ? ' hideContent' : '' }` }
            delay={ 300 }
        >
            <img
                alt='TABULA'
                src={logo}
                className='logo'
            />
            {
                tab === 1 ? (
                    <FadeIn delay={300}>
                        <p className='description small'>
                            New issues of&nbsp;
                            <span className='numeral'>
                                TABULA
                            </span>
                            &nbsp;(Latin for 'writing-tablet') are released each month. Each issue contains:
                        </p>
                        <ol>
                            <li>
                                <strong>Articles</strong>
                                &nbsp;from both Junior and Senior classics students at MGS
                            </li>
                            <li>
                                <strong>Puzzles</strong>&nbsp;&mdash;
                                Greek- and Roman-themed crosswords created by students, with prizes to be won!
                            </li>
                            <li>
                                <strong>Recommended reading</strong>&nbsp;&mdash;
                                our favourite books and reads from, based on, or inspired by Greek and Roman mythology
                            </li>
                            <li>
                                <strong>News</strong>&nbsp;&mdash;
                                the latest stories about what's new about the old: news about discoveries & explorations related to Classics
                            </li>
                            <li>
                                <strong>Memes</strong>&nbsp;&mdash;
                                a glance at the latest, funniest memes about our favourite Greek and Roman languages and mythologies
                            </li>
                        </ol>
                    </FadeIn>
                ) : (
                    <p className='description'>
                        MGS's latest news, thoughts, opinions and more about everything that's Classics
                    </p>
                )
            }

            <div className='option-buttons'>
                <button onClick={ switchTab }>
                    {
                        tab ? 'Back' : 'Learn more'
                    }
                </button>
                <button onClick={() => history.push('/all')}>
                    See inside
                </button>
            </div>
        </FadeIn>
    );
}
